export default {
  releaseNotes: 'RELEASE_NOTES',
};
